import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const EMOTIONS = [
  "Joy", "Melancholy", "Hope", "Grief", "Serenity", "Longing",
  "Rage", "Wonder", "Nostalgia", "Fear", "Love", "Solitude",
];

export const ART_TYPES = [
  { value: "visual", label: "Visual Art" },
  { value: "writing", label: "Writing / Poetry" },
  { value: "music", label: "Music" },
  { value: "video", label: "Video" },
];

// Supportive, human reactions instead of a plain "like"
export const REACTIONS = [
  { type: "hope", label: "This gave me hope", short: "Hope", icon: "Sprout" },
  { type: "moved", label: "This moved me", short: "Moved", icon: "Heart" },
  { type: "feel", label: "I feel this deeply", short: "Felt", icon: "HandHeart" },
  { type: "beauty", label: "Pure beauty", short: "Beauty", icon: "Sparkles" },
  { type: "brave", label: "So brave", short: "Brave", icon: "Flame" },
  { type: "notalone", label: "You're not alone", short: "Not alone", icon: "Users" },
];

export const REACTION_MAP = Object.fromEntries(REACTIONS.map((r) => [r.type, r]));
